import {
  STORAGE_KEYS,
  getStorageItem,
  removeStorageItem,
  setStorageItem
} from './storage'

export function getToken() {
  return getStorageItem(STORAGE_KEYS.TOKEN)
}

export function setToken(token) {
  setStorageItem(STORAGE_KEYS.TOKEN, token)
}

export function removeToken() {
  removeStorageItem(STORAGE_KEYS.TOKEN)
}
